<template>
  <div :class="['flex flex-col', genisSinifi]" data-form-alan>
    <label v-if="etiket" :for="hedefId" :class="['mb-1 text-gray-800 dark:text-gray-100', kompakt ? 'font-semibold text-xs' : 'font-bold text-sm']">
      {{ etiket }}
      <span v-if="zorunlu" class="renk-olumsuz" aria-hidden="true">*</span>
      <!-- RTS1: "bu nedir" ipucu — etiketin yanında ikon, üstüne gelince/dokununca açıklama -->
      <i v-if="bilgi" v-tooltip.top="{ value: bilgi, autoHide: false }" tabindex="0" role="img" :aria-label="bilgi"
        class="pi pi-info-circle ml-1 align-middle cursor-help text-xs text-gray-400 hover:text-primary focus:text-primary focus:outline-none"></i>
    </label>

    <slot></slot>

    <!-- Satir ici hata ya da ipucu; hata varsa ipucu gizlenir (ayni yerde tek mesaj) -->
    <small v-if="hata" class="mt-1 renk-olumsuz flex items-center gap-1" data-form-hata>
      <i class="pi pi-exclamation-circle text-xs" aria-hidden="true"></i>{{ hata }}
    </small>
    <small v-else-if="ipucu" class="mt-1 text-gray-500 dark:text-gray-400">{{ ipucu }}</small>
  </div>
</template>

<script>
// Form alani — etiket + zorunlu isareti + satir ici hata/ipucu icin ortak kapsayici.
// Icindeki gercek input (InputText/Select/vs.) slot olarak geliyor; :invalid ustten
// verilmeye devam eder, bu bilesen sadece cevresini standartlastirir.
// Kayit yeri: main.js (global). Import gerekmez.
import { kaydirIste } from "@/services/formHata";
export default {
  name: "FormAlan",
  // S360-A: bkz. FormBolum — saglayici konsolunda etiket kucuk.
  inject: { kompakt: { from: "konsolModu", default: false } },
  props: {
    etiket: { type: String, default: "" },
    zorunlu: { type: Boolean, default: false },
    // Doluysa satir ici hata olarak gosterilir (kirmizi)
    hata: { type: String, default: "" },
    // hata yoksa gosterilecek yardimci metin (gri)
    ipucu: { type: String, default: "" },
    // RTS1: etiketin yanında (i) ikonu + tooltip — "bu alan ne işe yarar" açıklaması
    bilgi: { type: String, default: "" },
    // label'in for'u + slot icindeki input'un id'si ayni olmali
    hedefId: { type: String, default: "" },
    // grid icinde kac sutun kaplasin: "" (1), "span-2", "full"
    genis: { type: String, default: "" },
  },
  watch: {
    // FH1: hata belirince ilk hatalı alan görünmüyorsa ona kaydır (services/formHata.js)
    hata(yeni, eski) {
      if (yeni && !eski) kaydirIste();
    },
  },
  computed: {
    genisSinifi() {
      if (this.genis === "span-2") return "md:col-span-2";
      if (this.genis === "full") return "col-span-full";
      return "";
    },
  },
};
</script>
